/**
 * Formatação regional das informações exibidas ao usuário. Só apresentação: os valores internos,
 * as unidades físicas e a serialização técnica (API, CSV, GeoJSON) não dependem do idioma.
 */
export const IDIOMAS = ['pt-BR', 'en'];
export const IDIOMA_PADRAO = 'pt-BR';
export function ehIdioma(valor) {
    return valor === 'pt-BR' || valor === 'en';
}
const LIMITE_DE_METROS_PARA_KM = 1000;
const LIMITE_DE_M2_PARA_HECTARES = 10_000;
const LIMITE_DE_M2_PARA_KM2 = 1_000_000;
function comoData(valor) {
    const data = valor instanceof Date ? valor : new Date(valor);
    return Number.isNaN(data.getTime()) ? null : data;
}
export function criarFormatadores(idioma) {
    const numero = (valor, opcoes) => new Intl.NumberFormat(idioma, opcoes).format(valor);
    const decimais = (maximo) => (valor) => numero(valor, { maximumFractionDigits: maximo });
    const formatoData = new Intl.DateTimeFormat(idioma, { dateStyle: 'short' });
    const formatoDataHora = new Intl.DateTimeFormat(idioma, { dateStyle: 'short', timeStyle: 'medium' });
    const formatoHora = new Intl.DateTimeFormat(idioma, { timeStyle: 'medium' });
    const comoTexto = (formato) => (valor) => {
        const data = comoData(valor);
        return data === null ? String(valor) : formato.format(data);
    };
    const umaCasa = decimais(1);
    const duasCasas = decimais(2);
    return {
        numero,
        inteiro: decimais(0),
        data: comoTexto(formatoData),
        dataHora: comoTexto(formatoDataHora),
        hora: comoTexto(formatoHora),
        comprimento: (metros) => metros < LIMITE_DE_METROS_PARA_KM
            ? `${umaCasa(metros)} m`
            : `${duasCasas(metros / 1000)} km`,
        area: (metrosQuadrados) => {
            if (metrosQuadrados < LIMITE_DE_M2_PARA_HECTARES) {
                return `${umaCasa(metrosQuadrados)} m²`;
            }
            if (metrosQuadrados < LIMITE_DE_M2_PARA_KM2) {
                return `${duasCasas(metrosQuadrados / 10_000)} ha`;
            }
            return `${duasCasas(metrosQuadrados / 1_000_000)} km²`;
        },
    };
}
